import Game from './Game.js'

class Main {
    
    constructor() {
        this.game = null
    }
    
    run() {
        const canvas = document.getElementById('main');
        const ctx = canvas.getContext('2d');
        this.game = new Game(ctx, 'wss://geim.vaps.ee/wss/');
        this.game.init();
        
        window.requestAnimationFrame((timestamp) => {
            this.draw(timestamp)
        });
    }
    
    draw(timestamp) {
        this.game.draw(timestamp)
        window.requestAnimationFrame((ts) => {
            this.draw(ts)
        });
    }
    
}

export default Main
